import { jsPDF } from "jspdf";

// Load the Helvetica font file from public directory
const loadHelveticaFont = async () => {
  try {
    const response = await fetch("/fonts/helvetica/Helvetica.ttf");
    const arrayBuffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    // Convert to base64
    let binary = "";
    for (let i = 0; i < uint8Array.length; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    return btoa(binary);
  } catch (error) {
    console.error("Failed to load Helvetica font:", error);
    return null;
  }
};

export const registerHelveticaFont = async (doc: jsPDF) => {
  try {
    const helveticaBase64 = await loadHelveticaFont();

    if (helveticaBase64) {
      // Add the font to jsPDF's virtual file system
      doc.addFileToVFS("Helvetica-Regular.ttf", helveticaBase64);

      // Register the font with jsPDF
      doc.addFont("Helvetica-Regular.ttf", "Helvetica-Regular", "normal");

      console.log("Helvetica font registered successfully");
      return true;
    } else {
      console.warn("Failed to load Helvetica font, using fallback");
      return false;
    }
  } catch (error) {
    console.error("Error registering Helvetica font:", error);
    return false;
  }
};

// Alternative: Use FreeSans as a fallback (metrically identical to Helvetica)
export const registerFreeSansFont = async (doc: jsPDF) => {
  try {
    // You can replace this with FreeSans.ttf if you have it
    const response = await fetch("/fonts/helvetica/Helvetica.ttf");
    const arrayBuffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    let binary = "";
    for (let i = 0; i < uint8Array.length; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    const fontBase64 = btoa(binary);

    doc.addFileToVFS("FreeSans.ttf", fontBase64);
    doc.addFont("FreeSans.ttf", "FreeSans", "normal");

    console.log("FreeSans font registered successfully");
    return true;
  } catch (error) {
    console.error("Error registering FreeSans font:", error);
    return false;
  }
};
